import React, { Component, createRef } from 'react'
import { Alert, Icon, Input } from "antd"
import PropTypes from 'prop-types'

class InputBarcode extends Component {
    state = {
        error: ''
    }

    _input = createRef()

    _handleSubmit = (e) => {
        e.preventDefault()

        this.setState({
            error: ''
        })

        const { value, onSubmit } = this.props

        if (!value || !value.trim()) return false

        // const regex = /^#([1-9][0-9]{5,})(_[0-9]+)/
        const check = /^#\d+_\d+$/.test(value)

        if (!check) {
            const { onClose } = this.props

            onClose(() => {
                this._input.current.focus()
            })

            return this.setState({
                error: 'Định dạng barcode không đúng vui lòng kiểm tra lại'
            })
        }

        if (typeof onSubmit === 'function') {
            onSubmit(value)
        }
    }

    _handleOnChange = e => {
        const { value } = e.target
        const { onChange } = this.props

        if (typeof onChange === 'function') {
            onChange(value)
        }
    }

    _handleClear = e => {
        e.preventDefault()

        const { onClose } = this.props
        onClose(() => {
            this._input.current.focus()
        })
    }

    render() {
        const { value, loading } = this.props
        const { error } = this.state

        return (
            <div className="InputBarcode mb-5">
                <form onSubmit={this._handleSubmit}>
                    <div className='position-relative'>
                        <Input size='large' autoFocus
                            readOnly={loading}
                            value={value}
                            ref={this._input}
                            onChange={this._handleOnChange}
                            className='InputSearch'
                            placeholder='Nhập item cần gộp'
                        />
                        {!!value &&
                            <div onClick={this._handleClear} className='position-absolute IconClear'>
                                <Icon type="close-circle" theme="filled" />
                            </div>
                        }
                    </div>

                    {
                        error && <Alert message={error} type='error' className='mt-3' />
                    }
                </form>
            </div>
        )
    }
}

InputBarcode.propTypes = {
    value: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default InputBarcode